<template>
    <pop-form v-if="show" width="990px" body-max-height="547px">
        <template v-slot:title>
            {{title}}
            <span class="close" @click="close">
                <i class="el-icon-close"></i>
            </span>
        </template>
        <div class="history-box">
            <div class="search-box">
                <el-date-picker
                        v-model="startDate"
                        type="date"
                        style="width: 150px"
                        placeholder="选择开始日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-date-picker
                        v-model="endDate"
                        type="date"
                        style="width: 150px"
                        placeholder="选择结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-select v-model="state" placeholder="请选择" style="width: 150px">
                    <el-option
                            v-for="item in stateArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>&nbsp;&nbsp;
                <el-select v-model="numState" placeholder="请选择" style="width: 150px">
                    <el-option
                            v-for="item in numStateArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>&nbsp;&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
            </div>

            <div class="list-box store-user-money-data">
                <el-table :data="tableData" style="width: 100%" height="430"  cell-class-name="list-table-ceil"
                          header-cell-class-name="list-table-ceil">
                    <el-table-column prop="create_datetime" label="时间" width="160" />
                    <el-table-column prop="state" label="状态" width="60" />
                    <el-table-column prop="expire" label="有效期至" width="100" />
                    <el-table-column prop="title" label="项目名称" width="100" :show-overflow-tooltip="true" />
                    <el-table-column prop="price" label="单价" width="60" />
                    <el-table-column prop="all_num" label="赠送次数" width="80" />
                    <el-table-column prop="use_num" label="使用次数" width="80" />
                    <el-table-column prop="sur_num" label="剩余次数" width="80" />
                    <el-table-column prop="sf_mobile" label="收银员" width="120" />
                    <el-table-column prop="remark" label="备注" width="" :show-overflow-tooltip="true" />
                </el-table>
            </div>
        </div>
        <template v-slot:foot>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper, slot"
                        :total="page.count">
                </el-pagination>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "StoreUserGiveProductHistory",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            title: "赠送项目",
            startDate: "",
            endDate: "",
            orderNo: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },

            //分页
            page: {
                nowPage: 1,
                pageSize: 20,
                pageSizes: [20, 50, 100],
                count: 0,
            },
            tableData: [],

            state: "",
            stateArr: [
                {
                    label: "所有状态",
                    value: ""
                }, {
                    label: "有效",
                    value: 1
                }, {
                    label: "无效",
                    value: -1
                }
            ],
            numState: "",
            numStateArr: [
                {
                    label: "所有剩余次数",
                    value: ""
                }, {
                    label: "剩余次数不为0",
                    value: 1
                }
            ],
        }),
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            },

            //当前页码变化
            pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            },

            //关闭
            close: function () {
                this.$emit("showChange", false);
            },
            //搜索提交
            searchEvent: function () {
                this.loadListData();
            },
            //加载数据
            loadListData: function () {
                let postData = {
                    store_uid: this.storeUid,
                    start_date: this.startDate ? this.startDate : "",
                    end_date: this.endDate ? this.endDate : "",
                    state: this.state,
                    sur_state: this.numState,
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                };
                obj.postData("store_user/get_give_product_history", postData, function (res) {
                    if(res.errcode === 0){
                        this.page.count = res.count;
                        this.tableData = res.data;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }
        },
        watch: {
            show: function (v) {
                if(v) this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        line-height: 24px;
    }
    .history-box{
        height: 500px;
        overflow: hidden;
        padding: 0px 10px;
    }
    .search-box{
        margin-top: 10px;
    }
    .list-box{
        margin-top: 20px;
    }
    .page-box{
        text-align: right;
    }
    .void-icon{
        position: absolute;
        top: 10px;
        right: 10px;
        opacity: 0.7;
    }
</style>
<style>
    .store-user-money-data .el-table th{
        background-color: #f4f4f4;
        padding: 7px 0px;
    }
</style>
